<template>
  <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
    <a-card style="height: 620px; margin-top: 10px">
      <div class="content">
        <a-empty style="margin-top: 80px" v-if="!isData" />
        <div v-if="isData">
          <div v-if="queryField === 'clean_flow' && totalCumulant !== null" class="total-flow">
            <span class="total-label">累积量总和：</span>
            <span class="total-value">{{ totalCumulant.toFixed(2) }} m³</span>
            <span v-if="hasMissingData" class="missing-data-tip">
              <a-icon type="exclamation-circle" theme="filled" />
              <span>缺失数据</span>
            </span>
          </div>
          <div v-if="(queryField === 'net_flow' || queryField === 'night_flow' || queryField === 'flow_day')
            && totalNetFlow !== null" class="total-flow">
            <span class="total-label">{{ queryField === 'net_flow' ? '片区净流量总和：' :
              queryField === 'night_flow' ? '夜间最小流量总和：' :
                queryField === 'flow_day' ? '日高峰流量总和：' : '' }}</span>
            <span class="total-value">{{ totalNetFlow.toFixed(2) }} m³</span>
            <a v-if="queryField === 'night_flow'" 
               class="dual-track-link" 
               @click="goToDualTrackWarning">
              双轨预警算法分析 →
            </a>
          </div>
          <a-spin :spinning="chartLoading">
            <div ref="echartsRef" class="statistics-chart" style="width: 100%; height: 500px; margin-top: 10px"></div>
          </a-spin>
        </div>
      </div>
    </a-card>
  </a-col>
</template>

<script>
import { getUUID } from '@/utils/util'
import notification from 'ant-design-vue/es/notification'
import axios from 'axios'
import storage from 'store'
import moment from 'moment'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { generateDataViewContent } from './chartOptionUtils'

var waterNameArr = {}
export default {
  props: {
    chartType: {
      type: String,
      required: false,
      default: 'line',
    },
    //当前片区下面的水表对象
    zonewaterMeter: {
      type: Object,
      required: false,
    },
    //显示规则
    showZoneRule: {
      type: Object,
      default: undefined,
    },
    //指标类型
    queryField: {
      type: String,
      required: false,
    },
    zoneName: {
      type: String,
      required: false,
    },
  },
  components: {},
  data () {
    return {
      isData: false,
      data: [],
      id: getUUID(),
      chartLoading: false,
      queryParams: {},
      queryUrl: '/pipe-network/report/chart/night-traffic/cleanFlow',
      queryUrl2: '/pipe-network/report/chart/night-traffic/flowRate',
      queryUrl3: '/pipe-network/report/chart/night-traffic/netFlow',
      queryUrl4: '/pipe-network/report/chart/night-traffic/iDelivery',
      queryUrl5: '/zone-metering/report/chart/night-traffic/iDelivery',
      queryUrl6: '/zone-metering/report/chart/night-traffic/cleanFlow',
      queryFieldName: '',
      totalNetFlow: null,
      totalCumulant: null,
      cumulant: null,
      missingDataList: [],
      negativeMeterarr: [], // 存储负表编号
      // 基础颜色数组
      baseColors: ['#5470C6', '#91CC75', '#FAC859', '#F9CFC5'],
    }
  },
  mounted () {
    this.setOption('mounted->setOption')
  },
  computed: {
    hasMissingData () {
      return this.queryField === 'clean_flow' && Array.isArray(this.missingDataList) && this.missingDataList.length > 0
    }
  },
  methods: {
    // 动态生成颜色数组的公共方法
    generateColorArray (legendData, seriesCount) {
      const colors = []
      let baseColorIndex = 0

      for (let i = 0; i < seriesCount; i++) {
        let color
        if (legendData && legendData[i]) {
          // 片区流量和对比流量使用特定颜色
          if (legendData[i] === '片区流量' || legendData[i] === '片区净流量') {
            color = '#5ad8dd'
          } else if (legendData[i] === '对比流量') {
            color = '#df84ea'
          } else {
            // 其他使用基础颜色循环
            color = this.baseColors[baseColorIndex % this.baseColors.length]
            baseColorIndex++
          }
        } else {
          // 如果没有legendData，使用基础颜色循环
          color = this.baseColors[baseColorIndex % this.baseColors.length]
          baseColorIndex++
        }
        colors.push(color)
      }
      return colors
    },

    // 获取安全颜色的公共方法
    getSafeColor (colorArray, index, fallbackColor = '#5470C6') {
      return index < colorArray.length ? colorArray[index] : fallbackColor
    },

    // 获取当前需要的颜色数量
    getRequiredColorCount (dataSeriesCount, minCount = 10) {
      return Math.max(dataSeriesCount, minCount)
    },

    // 获取分区计量规则
    async getCalculateRule () {
      if (!this.queryParams.zoneId) {
        console.warn('zoneId is not defined')
        return
      }

      try {
        const { data } = await this.$http.get('zone-metering/calculate-rule', {
          params: { zoneId: this.queryParams.zoneId },
        })

        if (!data.list || !data.list.length) {
          return
        }

        const rule = data.list[0]
        if (!rule.value) {
          return
        }

        // 处理计算规则值
        const processedValue = rule.value
          .replace(/\s/g, '') // 移除空格
          .replace(/\+/g, ',') // 替换加号为逗号
          .replace(/-/g, ',-') // 处理负数

        // 分割并过滤负数水表
        this.negativeMeterarr = processedValue
          .split(',')
          .filter((number) => number.startsWith('-'))
          .map((number) => number.replace(/-/g, ''))
      } catch (error) {
        console.error(error)
        this.$message.error('获取计算规则失败')
      }
    },

    // 修改 getList 方法
    async getList (params) {
      this.queryParams = params
      this.chartLoading = true
      // 先渲染容器，保证 a-spin 可见并覆盖加载过程
      this.isData = true
      this.totalNetFlow = null
      this.totalCumulant = null
      this.cumulant = null

      try {
        await this.getCalculateRule() // 获取计算规则
        // 夜间流量、日高峰
        if (params.queryField === 'night_flow' || params.queryField === 'flow_day') {
          await this.getNightChart(params)
        } else {
          await this.getChart(params)
        }
      } catch (error) {
        console.error(error)
        this.$message.error('图表加载失败')
        this.isData = false
      } finally {
        this.chartLoading = false
      }
    },

    //这个函数会将类似于[1, 2, 3, 7, 8, 9, 12, 13]这样的数组转换成[[1, 3], [7, 9], [12, 13]]这样的区间数组。它通过连续元素的差值是否为1来判断区间的结束点
    arrayToSegments (arr) {
      let segments = []
      for (let i = 0; i < arr.length; i++) {
        let start = arr[i]
        let end = start
        // 寻找区间的结束点
        while (arr[i + 1] - arr[i] === 1) {
          end = arr[++i]
        }
        segments.push([start, end])
      }
      return segments
    },
    setOption (title, legendData, xAxis, series, yAxis, tooltip, legend_isSelect, visualMap, cumulant) {

      this.totalCumulant = null
      let that = this
      if (cumulant) {
        this.cumulant = cumulant
      }
      let colspan = null
      let colspan2 = null
      var th = ''
      let queryFieldName = ''
      if (legendData) {
        if (legendData.indexOf('对比流量') > -1) {
          colspan = 4
          colspan2 = series.length + 2 - colspan
        } else {
          colspan = 2
          colspan2 = series.length + 1 - colspan
        }
      }

      if (this.queryField == 'flow_rate') {
        queryFieldName = '瞬时流量'
        th = `<th  colspan="${colspan2}" style="padding:5px 10px" v-if='${that.queryField} == 'flow_rate''>计量仪表</th> `
      } else if (this.queryField == 'night_flow') {
        queryFieldName = '夜间最小流量'
        if (legendData) {
          if (legendData.indexOf('3点对比流量') > -1) {
            colspan = 8
          } else {
            colspan = 4
          }
        }
      } else if (this.queryField == 'clean_flow') {
        queryFieldName = '累积量'
        th = `<th  colspan="${colspan2}" style="padding:5px 10px" v-if='${that.queryField} == 'flow_rate''>计量仪表</th> `
      } else if (this.queryField == 'flow_day') {
        queryFieldName = '日高峰流量'
        if (legendData) {
          if (legendData.indexOf('7点对比流量') > -1) {
            colspan = 8
          } else {
            colspan = 4
          }
        }
      } else if (this.queryField == 'net_flow') {
        queryFieldName = '净流量'
        th = `<th  colspan="${colspan2}" style="padding:5px 10px" v-if='${that.queryField} == 'flow_rate''>计量仪表</th> `
      }
      that.queryFieldName = queryFieldName
      // 定义基础图标路径
      const baseIcons1 = [
        require('@/assets/partition/workbench/blue1.png'),
        require('@/assets/partition/workbench/green1.png'),
        require('@/assets/partition/workbench/yellow1.png'),
        require('@/assets/partition/workbench/pink1.png'),
      ]

      const baseIcons2 = [
        require('@/assets/partition/workbench/blue2.png'),
        require('@/assets/partition/workbench/green2.png'),
        require('@/assets/partition/workbench/yellow2.png'),
        require('@/assets/partition/workbench/pink2.png'),
      ]

      // 动态创建图标数组，确保有足够的图标
      const createIconArray = (baseIcons, count) => {
        const result = []
        for (let i = 0; i < count; i++) {
          result.push(baseIcons[i % baseIcons.length])
        }
        return result
      }

      // 估算需要的图标数量，确保足够多
      const estimatedIconCount = legendData ? legendData.length + 4 : 12
      let icons1 = createIconArray(baseIcons1, estimatedIconCount)
      let icons2 = createIconArray(baseIcons2, estimatedIconCount)
      let waterMeterData = {
        inletWaterMeter: [], //进水表集合
        outletWaterMeter: []//出水表集合
      }
      let nowlegendarr = []

      if (legendData) {
        // 判断是否存在片区流量或片区净流量
        const hasZoneFlow = legendData.some((item) => item === '片区流量' || item === '片区净流量')
        // 判断是否存在对比流量
        const hasContrastFlow = legendData.includes('对比流量')

        legendData.map((item, i) => {
          // 默认图标配置
          let iconConfig = {
            name: item,
            icon: 'image://' + require('@/assets/partition/workbench/default2.png'),
          }

          // 特殊图标处理
          if (item === '片区流量' || item === '片区净流量') {
            iconConfig.icon = 'image://' + require('@/assets/partition/workbench/default2.png')
          } else if (item === '对比流量') {
            iconConfig.icon = 'image://' + require('@/assets/partition/workbench/default1.png')
          } else {
            // 计算图标索引
            let iconIndex = i
            if (hasZoneFlow) {
              iconIndex -= 1
            }
            if (hasContrastFlow) {
              iconIndex -= 1
            }

            // 判断是否为负表
            const isNegativeMeter = this.negativeMeterarr.includes(item)
            if (isNegativeMeter) {
              waterMeterData.outletWaterMeter.push(item)
            } else {
              waterMeterData.inletWaterMeter.push(item)
            }
            // 设置对应的图标
            iconConfig.icon = 'image://' + (isNegativeMeter ? icons2[iconIndex] : icons1[iconIndex])
          }

          nowlegendarr.push(iconConfig)
        })
      }
      var dome = this.$refs.echartsRef
      if (dome) {
        var myChart = echarts.init(dome)
        var option = {
          //  color: colorarr,
        title: {
          text: 'm³',
          textStyle: {
            fontWeight: 'normal', // 标题颜色
            color: '#101010',
          },
        },
          //图表偏移
          grid: {
            top: '80px',
            left: '90px',
            right: '83px',
            bottom: '80px',
          },
          tooltip: {
            // 提示框展示
            trigger: 'axis',
            ...tooltip,
          },
          legend: {
            // data: legendData,
            type: 'scroll',
            bottom: 10,
            data: title == 'getChart' ? nowlegendarr : legendData,
            width: 'auto',
            textStyle: {
              fontSize: 16,
            },
            formatter: function (name) {
              // if (contrast) {
              //   return name.replace(/对比流量/g, '');;
              // }
              return waterNameArr[name] != 'null' ? waterNameArr[name] : name
            },
            tooltip: {
              show: true,
              trigger: 'item',
            },
            selected: legend_isSelect,
            top: 20, // 下移图例位置
          },
          //工具栏
          toolbox: {
            top: 48,
            itemSize: 20,
            show: true,
            feature: {
              myToolData: {
                // 必须要my开头
                show: true,
                title: '数据导出',
                iconStyle: {
                  borderColor: '#ffffff',
                },
                icon: 'image://https://echarts.apache.org/zh/images/favicon.png',
                onclick: () => {
                  const url = `${process.env.VUE_APP_API_BASE_URL}pipe-network/report/chart/dataViewList`
                  const params = {
                    responseType: 'arraybuffer',
                    params: this.queryParams,
                    headers: { Authorization: storage.get(ACCESS_TOKEN) },
                  }
                  axios.get(url, params).then((res) => {
                    const blob = new Blob([res.data], { type: 'application/octet-stream;charset=utf-8' })
                    const fileName = that.zoneName + '-' + that.queryFieldName + '导出信息.xlsx'
                    const eLink = document.createElement('a')
                    eLink.download = fileName
                    eLink.style.display = 'none'
                    eLink.href = URL.createObjectURL(blob)
                    document.body.appendChild(eLink)
                    eLink.click()
                    URL.revokeObjectURL(eLink.href)
                    document.body.removeChild(eLink)
                    notification['success']({
                      message: '提示',
                      description: `输出导出成功`,
                      duration: 8,
                    })
                  })
                },
              },
              // dataZoom: {
              //   yAxisIndex: 'none'
              // },
              dataView: {
                readOnly: true,
                show: true,
                // lang: ['数据视图', '刷新', '关闭'],
                optionToContent: function (opt) {
                  const result = generateDataViewContent(opt, {
                    queryField: that.queryField,
                    zoneName: that.zoneName,
                    waterMeterData: waterMeterData,
                    cumulant: that.cumulant,
                    queryFieldName: queryFieldName,
                    initialColspan: colspan,
                    th: th
                  })
                  if (result.zoneCumulant !== null && result.zoneCumulant !== undefined) {
                    that.totalCumulant = result.zoneCumulant
                  }
                  return result.html
                },
              },
              magicType: { type: ['line', 'bar'] },
              restore: {},
              saveAsImage: {
                show: true,
                name: '（' + legendData.join('、') + '）流量图',
                excludeComponents: ['toolbox'],
                pixelRatio: 2,
              },
            },
          },
          xAxis: xAxis,
          yAxis: yAxis,
          dataZoom: [
            {
              type: 'slider', // 图表下方的伸缩条
              show: true, // 是否显示
              realtime: true, // 拖动时，是否实时更新系列的视图
              start: 0, // 伸缩条开始位置（1-100），可以随时更改
              end: 100, // 伸缩条结束位置（1-100），可以随时更改
            },
          ],
          series: series,
        }

        if (title == 'getChart') {
          option.visualMap = visualMap
        } else {
          // 动态生成颜色数组，确保有足够的颜色
          const estimatedColorCount = this.getRequiredColorCount(series ? series.length : 6, 6)
          option.color = this.generateColorArray(legendData, estimatedColorCount)
        }
        myChart.on('legendselectchanged', (e) => {
          // if (e.name === '对比:') {
          //   // 如果点击的是系列3，则恢复其显示状态
          //   myChart.setOption({
          //     legend: {
          //       selected: {
          //         '对比:': false
          //       }
          //     }
          //   });
          // }
          if (e.selected[e.name]) {
            navigator.clipboard.writeText(e.name)
          }
        })
        console.log(option.legend)

        if (this.showZoneRule) {
          option.legend.selected = this.showZoneRule
        }

        myChart.setOption(option, true)
        
        // 主动计算累积量总和（不依赖用户打开数据视图）
        if (that.queryField === 'clean_flow') {
          try {
            const currentOption = myChart.getOption()
            const result = generateDataViewContent(currentOption, {
              queryField: that.queryField,
              zoneName: that.zoneName,
              waterMeterData: waterMeterData,
              cumulant: that.cumulant,
              queryFieldName: queryFieldName,
              initialColspan: colspan,
              th: th
            })
            if (result.zoneCumulant !== null && result.zoneCumulant !== undefined) {
              that.totalCumulant = result.zoneCumulant
            }
          } catch (error) {
            console.error('计算累积量总和失败:', error)
          }
        }
        
        // 检测并刷新已打开的数据视图（仅在图表容器内查找）
        that.$nextTick(() => {
          setTimeout(() => {
            // 只在图表容器内查找数据视图
            if (!dome) return
            
            // ECharts 的数据视图是图表容器的直接子元素，查找包含表格的绝对定位 div
            let dataViewContainer = null
            const chartChildren = dome.querySelectorAll(':scope > div[style*="position"]')
            for (const child of chartChildren) {
              const style = child.getAttribute('style') || ''
              if (style.includes('absolute') && child.innerHTML && child.innerHTML.includes('<table')) {
                dataViewContainer = child
                break
              }
            }
            
            if (dataViewContainer) {
              console.log('找到数据视图容器，准备刷新')
              try {
                // 使用 getOption() 获取完整的 option 对象
                const currentOption = myChart.getOption()
                const result = generateDataViewContent(currentOption, {
                  queryField: that.queryField,
                  zoneName: that.zoneName,
                  waterMeterData: waterMeterData,
                  cumulant: that.cumulant,
                  queryFieldName: queryFieldName,
                  initialColspan: colspan,
                  th: th
                })
                if (result.zoneCumulant !== null && result.zoneCumulant !== undefined) {
                  that.totalCumulant = result.zoneCumulant
                }
                // 查找内容容器并更新
                const contentDom = dataViewContainer.querySelector('div[style*="overflow"]') || dataViewContainer
                if (contentDom) {
                  contentDom.innerHTML = result.html
                  console.log('✓ 数据视图已同步刷新')
                }
              } catch (error) {
                console.error('刷新数据视图失败:', error)
              }
            } else {
              console.log('数据视图未打开，无需刷新')
            }
          }, 300)
        })
        
        setTimeout(function () {
          window.onresize = function () {
            myChart.resize()
          }
        }, 200)
      }
    },
    // 选择夜间流量时加载的echart
    async getNightChart (params) {
      let flag = false
      this.isData = true
      var time1, time2
      params.tenantId = this.$store.state.user.info.tenantId
      if (params.queryBeginTime !== '') {
        time1 = params.queryBeginTime
      }
      if (params.queryEndTime !== '') {
        time2 = params.queryEndTime
      }
      this.queryParams = params
      
      // 并行请求夜间流量数据和基线数据
      const [nightFlowRes, baseLineRes] = await Promise.all([
        this.$http.get(this.queryUrl2, { params }),
        this.$http.get('/pipe-network/remote_water_meter_alarm_messages/alarm/base/line/zoneid/yj', {
          params: {
            zoneId: params.zoneId,
            startTime:  moment(params.queryBeginTime).format('YYYY-MM-DD'),
            endTime: moment(params.queryEndTime).format('YYYY-MM-DD'),
          }
        }).catch(err => {
          console.warn('获取基线数据失败:', err)
          return { data: [] }
        })
      ])
      
      const nightFlowData = nightFlowRes.data
      const baseLineData = baseLineRes.data || []
      
      console.log('基线数据:', baseLineData);

      this.totalNetFlow = 0
      const extra = nightFlowData.extra
      const arr = nightFlowData.dataList || []
      const arr2 = nightFlowData.differenceData || []

      const hasArr = Array.isArray(arr) && arr.length > 0 && Array.isArray(arr[0]) && arr[0].length > 0
      this.isData = hasArr
      if (!hasArr) {
        this.totalNetFlow = null
        return
      }

        console.log('夜间流量数据:', arr);
        var contrastxdata = []
        let flagOne = true;
        for (const items of arr[0]) {
          items.map((item1) => {
            item1.value = Number(item1.value)
            item1.appearanceName = item1.flowMeterNo.match(/\d+/g) + '点'
            if (!isNaN(item1.value)) {
              this.totalNetFlow += item1.value
            }
            return item1
          })
        }
        if (arr[1]) {
          flag = true
          for (const items of arr[1]) {
            items.map((item1, key) => {
              item1.value = Number(item1.value)
              console.log('item1', item1, key)

              if (flagOne) {
                const label = item1.label ? item1.label.substring(0, 10) : item1.label
                contrastxdata.push(label)
              }
              if (key == items.length - 1) {
                flagOne = false;
              }

              item1.appearanceName = item1.flowMeterNo.match(/\d+/g) + '点' + '对比流量'
              return item1
            })
          }
        }

        for (const items of arr2) {
          items.map((item1) => {
            item1.differenceValue = Number(item1.differenceValue)
            return item1
          })
        }
        console.log(contrastxdata);

        var datas = arr
        var title
        var legendData = []
        waterNameArr = {}
        var yAxis
        var xAxis
        var series = []
        var line
        var dataline // 用来接下面遍历的数据
        var tooltip


        title = arr[0][0].zoneName // 获取当前选择项的文本.
        if (datas !== '' && datas.length > 0) {
          // 循环查询或对比数据
          var xdata = []

          for (var i = 0; i < datas.length; i++) {
            var data = datas[i]

            // 循环有几条线

            for (var j = 0; j < data.length; j++) {
              var dat = data[j]
              var line_data = []
              // 循环数据获取数据

              for (var k = 0; k < dat.length; k++) {
                if (dat.length == 0) {
                  // 当没获取到y轴和x轴数据时,提示
                  // this.$message.error('没数据!')
                }

                if (dat[k].value != null) {
                  line_data.push(dat[k].value)
                  //x轴取查询时间
                  if (i == 0 && j == 0) {
                    const label = dat[k].label ? dat[k].label.substring(0, 10) : dat[k].label
                    xdata.push(label)
                  }
                }
              }



              console.log('xdata', xdata)

              dataline = [
                {
                  name: arr2[0][j].labelShow,
                  yAxis: arr2[0][j].differenceValue,
                  label: {
                    position: 'end',
                    formatter: arr2[0][j].labelShow,
                  },
                },
              ]
              yAxis = {
                type: 'value',
                //  axisLine: {
                //   onZero: false // y轴是否在x轴0刻度上
                // }
              }
              // 判断参考值是不是最大值（稍后会根据基线值调整）
              yAxis.max = Math.ceil(extra * 1.1)
              // yAxis.min =
              xAxis = {
                type: 'category',
                // 根据图表类型动态设置 boundaryGap：柱状图需要留边距防止溢出，折线图可以贯穿
                boundaryGap: this.chartType === 'bar' ? [0.1, 0.1] : false,
                data: xdata,
                contrastdata: contrastxdata, //对比流量的数据
              }
              line = {
                name: data[j][0].appearanceName,
                // type: 'bar',
                type: this.chartType,
                smooth: true,
                symbolSize: 4,
                showAllSymbol: false,
                markPoint: {
                  // 最大值和最小值水滴型自动展示
                  data: [
                    { type: 'max', name: '最大值' },
                    { type: 'min', name: '最小值' },
                  ],
                },
                data: line_data,
                itemStyle: {
                  normal: {
                    lineStyle: {
                      width: 2,
                      type: 'solid', // 'dotted'虚线 'solid'实线
                    },
                  },
                },
                markLine: {
                  // 辅助线展示
                  data: dataline,
                  label: {
                    fontSize: 16,
                  },
                },
                /* 空点连接 */
                connectNulls: true,
              }
              series.push(line)
              waterNameArr[data[j][0].appearanceName] = data[j][0].appearanceName
              legendData.push(data[j][0].appearanceName)
              // legendData.push(data[j][0].flowMeterNo.indexOf('的净流量') > -1 ? data[j][0].flowMeterNo.replace(/的净流量/g, '') : data[j][0].flowMeterNo)
            }
          }
          
          // 添加基线数据（取数组的baseLine）
          if (Array.isArray(baseLineData) && baseLineData.length > 0) {
            console.log('开始处理基线数据，数组长度:', baseLineData.length);
            const baseLineValues = []
            const moment = require('moment')
            
            // 为每个 xdata 点找到对应的基线值
            xdata.forEach(dateStr => {
              const matchingData = baseLineData.find(item => {
                if (!item || !item.localDate) return false
                try {
                  // 构建日期字符串进行匹配
                  const itemDate = `${item.localDate.year}-${String(item.localDate.monthValue).padStart(2, '0')}-${String(item.localDate.dayOfMonth).padStart(2, '0')}`
                  return dateStr.startsWith(itemDate)
                } catch (error) {
                  console.error('解析基线日期失败:', error, item)
                  return false
                }
              })
              
              // 从数组中取baseLine值
              if (matchingData && matchingData.baseLine !== null && matchingData.baseLine !== undefined) {
                const baseLineValue = Number(matchingData.baseLine)
                baseLineValues.push(isNaN(baseLineValue) ? null : baseLineValue)
              } else {
                baseLineValues.push(null)
              }
            })
            
            console.log('基线值数组:', baseLineValues);
            
            // 只有当基线数据不全为 null 时才添加
            if (baseLineValues.some(v => v !== null)) {
              // 统计非 null 的基线值
              const validBaseLineValues = baseLineValues.filter(v => v !== null)
              const baseLineValue = validBaseLineValues[0] // 获取第一个有效值
              
              // 如果只有一个基线值，使用 markLine 方式显示（类似参考值）
              if (validBaseLineValues.length === 1) {
                // 创建一个独立的系列，使用 markLine 显示水平线，这样可以在图例中显示
                // 注意：data 使用基线值而不是 null，这样 tooltip 才能正常显示
                const baseLineSeries = {
                  name: '基线',
                  type: 'line',
                  data: xdata.map(() => baseLineValue), // 使用基线值，确保 tooltip 能显示
                  markLine: {
                    data: [
                      {
                        name: '基线',
                        yAxis: baseLineValue,
                        label: {
                          position: 'end',
                          formatter: '基线',
                          fontSize: 16,
                        },
                        lineStyle: {
                          type: 'dashed',
                          color: '#12C6B2',
                          width: 2
                        }
                      }
                    ],
                    label: {
                      fontSize: 16,
                    },
                    lineStyle: {
                      type: 'dashed',
                      color: '#12C6B2',
                      width: 2
                    }
                  },
                  itemStyle: {
                    normal: {
                      lineStyle: {
                        width: 0, // 隐藏线条，只显示 markLine
                        color: '#12C6B2'
                      },
                      color: '#12C6B2'
                    }
                  },
                  symbol: 'none', // 不显示数据点
                  // 确保 tooltip 能正常显示
                  tooltip: {
                    show: true
                  }
                }
                
                series.push(baseLineSeries)
                waterNameArr['基线'] = '基线'
                legendData.push('基线')
                console.log('基线已作为 markLine 添加到独立系列，值:', baseLineValue);
              } else {
                // 多个基线值，使用 line 系列方式
                const baseLineSeries = {
                  name: '基线',
                  type: 'line', // 强制使用线条类型，不跟随chartType变化
                  smooth: true,
                  symbolSize: 4,
                  showAllSymbol: false,
                  data: baseLineValues,
                  itemStyle: {
                    normal: {
                      lineStyle: {
                        width: 1,
                        type: 'dashed',  
                        color: '#12C6B2'
                      },
                      color: '#12C6B2'
                    }
                  },
                  connectNulls: true
                }
                
                series.push(baseLineSeries)
                waterNameArr['基线'] = '基线'
                legendData.push('基线')
                console.log('基线系列已添加到图表（多个值）');
              }
              
              // 调整 Y 轴最大值，确保基线值能够完整显示
              const maxBaseLine = Math.max(...validBaseLineValues)
              if (maxBaseLine && yAxis.max < maxBaseLine) {
                yAxis.max = Math.ceil(maxBaseLine * 1.1)
                console.log('基线最大值超出，调整Y轴最大值为:', yAxis.max);
              }
            } else {
              console.warn('所有基线值都为null，不显示基线');
            }
          } else {
            console.log('基线数据为空或不是数组:', baseLineData);
          }

          // 调整 Y 轴最大值，确保参考线值（differenceValue）能完整显示
          if (arr2 && arr2[0] && arr2[0].length > 0) {
            const maxDiffVal = Math.max(...arr2[0].map(item => Number(item.differenceValue) || 0))
            if (maxDiffVal && yAxis.max < maxDiffVal) {
              yAxis.max = Math.ceil(maxDiffVal * 1.1)
              console.log('参考线超出Y轴，调整Y轴最大值为:', yAxis.max)
            }
          }

          // 调整 Y 轴最大值，确保实际数据值能完整显示
          const allDataValues = series
            .filter(s => s.name !== '基线')
            .flatMap(s => (s.data || []).filter(v => v !== null && v !== undefined).map(Number))
            .filter(v => !isNaN(v))
          if (allDataValues.length > 0) {
            const maxDataVal = Math.max(...allDataValues)
            if (maxDataVal && yAxis.max < maxDataVal) {
              yAxis.max = Math.ceil(maxDataVal * 1.1)
              console.log('实际数据超出Y轴，调整Y轴最大值为:', yAxis.max)
            }
          }

          tooltip = {
            formatter: function (params) {
              console.log(params.length)
              var allData = 0
              var result
              params.map((item) => {
                // 基线不计算到合计
                if (item.seriesName !== '基线') {
                  allData += parseFloat(item.data)
                }
              })
              result = '<div>' + params[0].axisValue + ' (合计:' + allData.toFixed(2) + ')</div>'

              params.forEach(function (item, index) {
                result +=
                  '<span style="display:inline-block;margin-right:5px;margin-bottom:2px;border-radius:10px;width:9px;height:9px;background:' +
                  item.color +
                  '"></span>'
                result += item.seriesName + '：' + item.data + '<br>'
              })
              return result
            },
          }
          // 插值数据处理
          this.setOption('getNightChart', legendData, xAxis, series, yAxis, tooltip, null, null, flag)
        } else {
          this.$message.error('没数据!')
        }
    },
    getChart (params) {
      this.isData = true
      this.missingDataList = []
      var time1, time2
      if (params.queryBeginTime !== '') {
        time1 = params.queryBeginTime
      }
      if (params.queryEndTime !== '') {
        time2 = params.queryEndTime
      }
      this.queryParams = params
      console.log(params);
      let url
      if (params.parallelBigUserIds) {
        if (params.queryField === 'clean_flow') {
          url = this.queryUrl6
        } else {
          url = this.queryUrl5
        }
      } else {
        url = params.queryField == 'net_flow'
          ? this.queryUrl3
          : params.queryField == 'flow_rate'
            ? this.queryUrl4
            : this.queryUrl
      }
      return this.$http
        .get(url, { params })
        .then(({ data }) => data)
        .then(async (data) => {
          this.missingDataList = Array.isArray(data.missingDataList) ? data.missingDataList : []
          const arr = data.data
          
          // 安全检查：确保有数据
          if (!arr || arr.length === 0 || !arr[0] || arr[0].length === 0) {
            this.$message.error('暂无数据！')
            this.isData = false
            return
          }
          
          const index = arr[0].length
          for (const items of arr) {
            if (items.length > index) {
              items.splice(index, items.length)
            }
            items.map((item1) => {
              return item1.value
            })
          }
          var datas = arr
          var title
          var legendData = []
          waterNameArr = {}
          var legend_isSelect = {}
          var yAxis
          var xAxis
          var series = []
          var visualMap = []
          var line
          var dataline
          var tooltip
          console.log('arr',arr);
          
          title = arr[0][0].zoneName
          var contrastxdata = []

          if (datas !== '' && datas.length > 0) {
            // 计算片区净流量总和
            if (params.queryField === 'net_flow' && datas[0][0].flowMeterNo === '片区净流量') {
              let total = 0
              datas[0].forEach((item) => {
                if (item.value !== null) {
                  total += Number(item.value)
                }
              })
              this.totalNetFlow = total
            }

            //每一条线
            for (var i = 0; i < datas.length; i++) {
              // console.log(i);
              var data = datas[i]
              var xdata = []
              var line_data = []
              var pieces = []
              //数据是null的下标组成的数组
              var nullkeyarr = []
              for (var j = 0; j < data.length; j++) {
                // 转成json字符串,获取动态参数key,再转成对象使用
                if (data.length == 0) {
                  // 当没获取到y轴和x轴数据时,提示
                  this.$message.error('没数据!')
                }
                //判断该项是null就补前面一项,除了第一项
                if (j > 0 && data[j].value == null) {
                  // console.log('null', j, data[j]);
                  data[j].value = data[j - 1].value
                  // this.redLinedata.push(data[j].value)
                  nullkeyarr.push(j)
                  //allnullarr.push(data[j])
                  //计算补差后的片区流量
                  // 当queryUrl4返回长度为2时，片区净流量也要补差
                  if (
                    (datas[0][0].flowMeterNo == '片区流量' || datas[0][0].flowMeterNo == '片区净流量') &&
                    (datas.length > 2 || (params.queryField == 'flow_rate' && datas.length == 2))
                  ) {
                    //判断表是不是负-表
                    if (this.negativeMeterarr.includes(data[j].flowMeterNo)) {
                      //负-表
                      datas[0][j].value = (Number(datas[0][j].value) - Number(data[j].value)).toFixed(2)
                    } else {
                      //正+表
                      datas[0][j].value = (Number(datas[0][j].value) + Number(data[j].value)).toFixed(2)
                    }
                  }
                }

                line_data.push(data[j].value)
                xdata.push(data[j].label)


                if (data[j].flowMeterNo == '对比流量') {
                  contrastxdata.push(data[j].label)
                }
                // }
              }
              /** 只显示平均线（累积量 clean_flow 不显示平均线） */
              dataline = params.queryField === 'clean_flow' ? [] : [{ type: 'average', name: '平均值' }]
              /** y轴刻度自显示 */
              yAxis = [
                {
                  type: 'value',
                  min: function (val) {
                    if (val.min > 0) {
                      return Math.floor(0)
                    }
                    return Math.floor(val.min)
                  },
                },
              ]
              xAxis = {
                type: 'category',
                boundaryGap: params.queryField == 'net_flow' ? true : false,
                data: xdata,
                contrastdata: contrastxdata, //对比流量的数据
              }

              if (
                data[0].flowMeterNo === '片区流量' ||
                data[0].flowMeterNo === '对比流量' ||
                data[0].flowMeterNo === '片区净流量'
              ) {
                waterNameArr[data[0].flowMeterNo] = `${data[0].flowMeterNo}`
                legendData.push(data[0].flowMeterNo)
                legend_isSelect[data[0].flowMeterNo] = true
              } else {
                waterNameArr[data[0].flowMeterNo] = `${data[0].appearanceName}`
                legendData.push(data[0].flowMeterNo)
                // 默认只显示第一个图例（i === 0），其他图例需要手动点击
                legend_isSelect[`${data[0].flowMeterNo}`] = i === 0
              }
              // 动态生成颜色数组
              const estimatedColorCount = this.getRequiredColorCount(datas.length, 10)
              var colorarr = this.generateColorArray(legendData, estimatedColorCount)
              console.log('生成的颜色数组:', colorarr, '数量:', colorarr.length, '数据系列数:', datas.length)
              line = {
                // type: 'line',
                name: data[0].flowMeterNo,
                allname: data[0].appearanceName
                  ? data[0].flowMeterNo + '（' + data[0].appearanceName + '）'
                  : data[0].flowMeterNo,
                type: this.chartType,
                symbolSize: 4,
                showAllSymbol: false,
                smooth: true,
                /* 空点连接 */
                connectNulls: true,
                markPoint: {
                  // 最大值和最小值水滴型自动展示
                  data: [
                    { type: 'max', name: '最大值' },
                    { type: 'min', name: '最小值' },
                  ],
                  itemStyle: {
                    color: this.getSafeColor(colorarr, i),
                  },
                },
                data: line_data,
                // 累积量下去掉平均值辅助线，其它指标保留
                markLine: dataline.length
                  ? {
                    // 辅助线展示
                    data: dataline,
                    label: {
                      fontSize: 16,
                    },
                    lineStyle: {
                      color: this.getSafeColor(colorarr, i),
                      width: 1,
                    },
                  }
                  : undefined,
              }
              //lt（小于，less than），gt（大于，greater than），lte（小于等于 less than or equals），gte（大于等于，greater than or equals）

              //补差的区间
              //1、瞬时流量补差
              // if (params.queryField == "flow_rate") {

              let redarr = this.arrayToSegments(nullkeyarr)
              for (let k = 0; k < redarr.length; k++) {
                if (k == 0) {
                  pieces.push({
                    lt: redarr[k][0],
                    color: this.getSafeColor(colorarr, i),
                  })
                }
                pieces.push({
                  gte: redarr[k][0],
                  lte: redarr[k][1],
                  color: 'red',
                })
                if (k + 1 < redarr.length) {
                  pieces.push({
                    gt: redarr[k][1],
                    lt: redarr[k + 1][0],
                    color: this.getSafeColor(colorarr, i),
                  })
                } else if (k + 1 == redarr.length) {
                  pieces.push({
                    gt: redarr[k][1],
                    color: this.getSafeColor(colorarr, i),
                  })
                }
              }
              // console.log('redarr', redarr)
              // 确保pieces中的每个项都有有效的颜色
              const safeColor = this.getSafeColor(colorarr, i)
              pieces.forEach((piece) => {
                if (!piece.color || piece.color === 'undefined') {
                  piece.color = safeColor
                }
              })

              if (redarr.length > 0) {
                visualMap.push({
                  seriesIndex: i, // 指定这两条线的索引
                  show: false,
                  dimension: 0,
                  //处理好的分段区间 index对应每个图表的分段数据
                  pieces: pieces,
                })
              } else {
                visualMap.push({
                  seriesIndex: i, // 指定这两条线的索引
                  show: false,
                  dimension: 0,
                  inRange: {
                    color: this.getSafeColor(colorarr, i),
                  },
                })
              }

              series.push(line)
            }

            if (series[0].name == '片区流量' || series[0].name == '片区净流量') {
              series[0].data = datas[0]
              //  console.log('a',series[0].data , datas[0]);
            }
            // 累积量现在只调用一次接口，直接使用当前返回结果绘制图表
            this.setOption('getChart', legendData, xAxis, series, yAxis, tooltip, legend_isSelect, visualMap)


          }
        })
    },
    
    // 跳转到双轨预警页面
    goToDualTrackWarning() {
      const moment = require('moment')
      const startTime = moment(this.queryParams.queryBeginTime).format('YYYY-MM-DD')
      const endTime = moment(this.queryParams.queryEndTime).format('YYYY-MM-DD')
      const returnFullPath = this.$route.fullPath
      const restoreState = encodeURIComponent(
        JSON.stringify({
          zoneId: this.queryParams.zoneId,
          queryBeginTime: this.queryParams.queryBeginTime,
          queryEndTime: this.queryParams.queryEndTime,
          queryField: this.queryParams.queryField || this.queryField,
          stepLength: this.queryParams.stepLength,
          parallelBigUserIds: this.queryParams.parallelBigUserIds
        })
      )
      
      // 跳转到双轨预警页面，传递分区ID和时间范围
      this.$router.push({
        path: '/zone-alarm-management/dual-track-warning',
        query: {
          zoneId: this.queryParams.zoneId,
          zoneName: this.zoneName,
          startTime: startTime,
          endTime: endTime,
          returnFullPath: returnFullPath,
          returnPath: this.$route.path,
          restoreState: restoreState
        }
      })
    }
  },
  watch: {
    chartLoading (val) {
      this.$emit('chart-loading', val)
    },
  },
}
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
}

.total-flow {
  padding: 10px 20px;
  background-color: #f5f5f5;
  border-radius: 4px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;

  .total-label {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }

  .total-value {
    font-size: 18px;
    color: #1890ff;
    margin-left: 10px;
  }

  .missing-data-tip {
    margin-left: 12px;
    color: #f5222d !important;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    font-weight: 600;

    .anticon {
      margin-right: 4px;
      color: #f5222d !important;
      font-size: 15px;
    }

    span {
      color: #f5222d !important;
    }
  }
  
  .dual-track-link {
    margin-left: auto;
    color: #1890ff;
    font-size: 14px;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.3s;
    padding: 6px 16px;
    border: 1px solid #1890ff;
    border-radius: 20px;
    
    &:hover {
      color: #fff;
      background-color: #40a9ff;
      border-color: #40a9ff;
    }
  }
}

</style>
